var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21967 9.20404C5.51256 8.91115 5.98744 8.91115 6.28033 9.20405L10 12.9237L13.7197 9.20405C14.0126 8.91115 14.4874 8.91115 14.7803 9.20405C15.0732 9.49694 15.0732 9.97181 14.7803 10.2647L10.5303 14.5147C10.3897 14.6554 10.1989 14.7344 10 14.7344C9.80109 14.7344 9.61032 14.6554 9.46967 14.5147L5.21967 10.2647C4.92678 9.97181 4.92678 9.49694 5.21967 9.20404Z",
    fill: "#0F172A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.f50a69bdaf21baa07fc6b72c46566bc9.svg";
export { ForwardRef as ReactComponent };